import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import { Loader2 } from 'lucide-react';
import { api } from '../services/api';
import './HandwritingPlace.css';

// A handwritten value of the scan's copy beside its place on the scan, so the reader checks the copy's
// reading of the hand (a name set in the spelling the language usually has, a letter misread).
function HandwritingPlace({ documentId, value, position, onMouseEnter, onMouseLeave }) {
  const { t } = useTranslation('components');
  const [image, setImage] = useState({ status: 'loading', url: null });

  useEffect(() => {
    let url = null;
    let cancelled = false;
    setImage({ status: 'loading', url: null });
    api.getHandwritingPlace(documentId, value.index)
      .then((blob) => {
        url = URL.createObjectURL(blob);
        if (cancelled) URL.revokeObjectURL(url);
        else setImage({ status: 'ready', url });
      })
      .catch((error) => {
        console.error('Handwriting place fetch failed:', error);
        if (!cancelled) setImage({ status: 'failed', url: null });
      });
    return () => {
      cancelled = true;
      if (url) URL.revokeObjectURL(url);
    };
  }, [documentId, value.index]);

  return ReactDOM.createPortal(
    <div
      className={`handwriting-place ${position.above ? 'above' : 'below'}`}
      style={{ left: `${position.x}px`, top: `${position.y}px` }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      data-testid="handwriting-place"
      role="dialog"
      aria-label={t('diff.handwritten.title')}
    >
      <div className="handwriting-place-title">{t('diff.handwritten.title')}</div>
      <div className="handwriting-place-scan">
        {image.status === 'loading' && <Loader2 size={18} className="handwriting-place-spinner" />}
        {image.status === 'ready' && (
          <img src={image.url} alt={t('diff.handwritten.alt', { text: value.text })} data-testid="handwriting-place-image" />
        )}
        {image.status === 'failed' && <span className="handwriting-place-failed">{t('diff.handwritten.failed')}</span>}
      </div>
      <div className="handwriting-place-copy">
        <span className="handwriting-place-label">{t('diff.handwritten.copy')}</span>
        <span className="handwriting-place-text">{value.text}</span>
      </div>
      <p className="handwriting-place-hint">{t('diff.handwritten.hint')}</p>
    </div>,
    window.document.body,
  );
}

export default HandwritingPlace;
